import React from "react";
import './Notes.scss';
import { closeNotes, closeAllView, showView } from "../../Menu/MenuSide/menuSideSlice";
import DataNoteClient from "./DataNoteClient/DataNoteClient";
//import { addMessage } from "../../Authorization/authSlice";

import { setOpenSendBox, onShadeView } from "../Contacts/contactsSlice";
import { mesHrefSetForShare } from "../Messages/messageslice";
import TroublesForQuiz from "../Troubles/TroublesForQuiz/TroublesForQuiz";
import Folderer from "./Folderer/Folderer";
import PdfViewer from "../../Admin/AdminView/AdminQuizes/AdminNote/PdfViewer/PdfViewer";


const Notes = (props) => {
    const { dispatch } = props;
    const onClickEnd = () =>{
        const moduleData = props.moduleData;

        if (moduleData.length === 0 && props.previousModule === 2) {
            dispatch(closeNotes());
            dispatch(showView(1));
        } else {
            dispatch(closeNotes());
            dispatch(showView(props.previousModule));
        }
       
    }

    const handleClickShare = () => {

        dispatch(setOpenSendBox());
        dispatch(onShadeView());
        dispatch(mesHrefSetForShare("2"));
      

    }
    const handleClickBackQuiz = () => {
        dispatch(closeAllView());
        dispatch(showView(3));

      

    }


    
    //RENDER
    const notesView = props.notesView;
    //console.log(props.dataNotes);
    if (notesView) {
        return (
            <div className="Notes">
                <div className="main">
                    <div className="return-menu">
                       <button className="exit" onClick={onClickEnd}></button>
                    </div>
                    
                    <div className="services">
                        {/*<button className="favorite"></button>*/}
                        {props.quizActive && <button className="quiz" onClick={handleClickBackQuiz}></button>}
                        {/*<button className="troubles"></button>*/}
                        {(props.authData.modulesName[2].status || (props.authData.userRole[0].role_id === 1)) ? <button className="share" onClick={handleClickShare}></button> : null}
                    </div>
                    <div className="title-div">
                        <p className="title">{props.notesDataSlice.selectedNoteId}. {props.notesDataSlice.selectedNoteName}</p>
                        <div className="row-div">
                            <p className="breadcrumbs">{props.notesDataSlice.selectedCategory} / {props.notesDataSlice.selectedSubCategory}</p>
                            <p className="status-note">{!props.notesDataSlice.public ? 'private' : 'public'}</p>
                        </div>
                        
                    </div>
                    
                </div>
                
                <DataNoteClient
                 authData ={props.authData}
                 dataNotes = {props.dataNotes}
                 selectedNoteId = {props.notesDataSlice.selectedNoteId}
                 dataTroubles = {props.dataTroubles}
                 dispatch = {dispatch}
                 
                />
                
                {props.troublesData.troublesViewForQuize && <TroublesForQuiz
                    troublesData={props.troublesData}
                    dataTroubles = {props.dataTroubles}
                    dataAnswerTroubles = {props.dataAnswerTroubles}
                    userId={props.userId}
                    selectedIdAnswerTrouble={props.selectedIdAnswerTrouble}
                    selectedIdTrouble={props.selectedIdTrouble}
                    dispatch = {dispatch}
                />}

                {props.foldererView && <Folderer
                    selectedIdNote = {props.notesDataSlice.selectedNoteId}
                    noteAddFiles = {props.noteAddFiles}
                    dispatch={dispatch}
                    />
                }
                {props.adminPdfViewer && <PdfViewer
                
                       
                    selectedIdNote = {props.notesDataSlice.selectedNoteId}
                    pdfName = {props.pdfName}

                    dispatch={dispatch}
                    />
                }

                

            </div> 
        )
    } else return null;
}
export default Notes;